export default __webpack_public_path__ + "static/media/gold_medal.f94ce2d7.svg";